export default __webpack_public_path__ + "static/skyline-4f47d1736002dbd6f1bcc35eb4f37dc8.svg";